import { render } from "./SoftImageInput.vue?vue&type=template&id=651a6f8e"
import script from "./SoftImageInput.vue?vue&type=script&lang=js"
export * from "./SoftImageInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__